import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'react-bootstrap';
import classNames from 'classnames';
import { FormContext } from './FormContext';
import FormInputLabel from './control/parts/FormInputLabel';
import FormInputHelp from './control/parts/FormInputHelp';

const FormInputContainer = ({
  children,
  className,
  controlId,
  dirty,
  disabled,
  errorMessage,
  field,
  hidden,
  noLabel,
  touched,
  valid,
  ...props
}) => {
  const { ee, trackDirty } = useContext(FormContext);

  const handleEvent = ({ action, payload }) => {
    switch (action) {
      case 'update':
        props.onUpdate(payload);
        break;

      case 'clear':
        props.onClear(payload);
        break;

      default:
        props.onEvent(payload);
    }
  };

  useEffect(() => {
    if (ee) {
      ee.on(controlId, handleEvent);

      return () => {
        ee.off(controlId);
      };
    }
  });

  const isDirty = dirty && valid && !field.readOnly && trackDirty;
  const isReadOnly = field.readOnly || disabled;
  const isDisplayOnly = field.displayOnly;
  const isInvalid = !valid && touched;

  const containerClass = classNames(
    {
      'is-invalid': isInvalid,
      'is-dirty': isDirty,
      'is-readonly': isReadOnly,
      'is-displayonly': isDisplayOnly,
      'is-hidden': hidden,
    },
    className
  );

  return (
    <FormGroup controlId={controlId} className={containerClass} key={controlId} id={`${controlId}-control`}>
      <FormInputLabel hide={noLabel}>{field.label}</FormInputLabel>
      {children}
      <FormInputHelp errorText={errorMessage}>{field.helpText}</FormInputHelp>
    </FormGroup>
  );
};

FormInputContainer.defaultProps = {
  dirty: false,
  disabled: false,
  errorMessage: '',
  field: {},
  hidden: false,
  noLabel: false,
  onClear: () => {},
  onEvent: () => {},
  onUpdate: () => {},
  touched: false,
  trackDirty: true,
  valid: true,
};

FormInputContainer.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  controlId: PropTypes.string,
  dirty: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  field: PropTypes.object,
  hidden: PropTypes.bool,
  noLabel: PropTypes.bool,
  onClear: PropTypes.func,
  onEvent: PropTypes.func,
  onUpdate: PropTypes.func,
  touched: PropTypes.bool,
  trackDirty: PropTypes.bool,
  valid: PropTypes.bool,
};

export default FormInputContainer;
